
  <app-camera></app-camera>




